import { useEffect, useMemo } from 'react';
import { useInView } from 'react-intersection-observer';

interface useInfiniteScrollLoadingTargetProps {
  isFetchingNextPage: boolean;
  hasNextPage: boolean;
  triggeredFnWhenInView: () => void;
}

export const useInfiniteScrollLoadingTarget = ({
  isFetchingNextPage,
  hasNextPage,
  triggeredFnWhenInView,
}: useInfiniteScrollLoadingTargetProps) => {
  const { ref: loadingTargetRef, inView: isLoadingTargetInView } = useInView();

  const isLoadingTargetRendered = useMemo<boolean>(() => {
    if (isFetchingNextPage) {
      return false;
    }

    if (!hasNextPage) {
      return false;
    }

    return true;
  }, [isFetchingNextPage, hasNextPage]);

  useEffect(() => {
    if (isLoadingTargetInView) {
      triggeredFnWhenInView();
    }
  }, [isLoadingTargetInView]);

  return { loadingTargetRef, isLoadingTargetRendered };
};
